import { useI18n } from "i18n";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { OS_NAMES } from "modules/systemCheck/constants";
import { DailyCameraErrorType } from "@daily-co/daily-js";
import { getMicCamTroubleshootLink } from "modules/systemCheck/utils/getMicCamTroubleshootLink";
import { DetectionTestBase } from "../../DetectionTestBase";
import {
  getDeviceInUseErrorHeading,
  getDeviceInUseErrorName,
  getDevicePromptContent,
  getStepOneOfDeviceError,
} from "./utils";

interface Props {
  isCameraErrorType: DailyCameraErrorType | null;
  osName: OS_NAMES;
}

export const DevicesInUse = ({ isCameraErrorType, osName }: Props) => {
  const { t } = useI18n(["micCamCheck", "url", "settings"]);

  if (
    !isCameraErrorType ||
    isCameraErrorType === "permissions" ||
    isCameraErrorType === "not-found"
  ) {
    return null;
  }

  return (
    <DetectionTestBase
      testName={t(getDeviceInUseErrorHeading(isCameraErrorType))}
      testResult={
        <span>
          <Typography variant="body1" style={{ whiteSpace: "pre-line" }}>
            {t(getDevicePromptContent(isCameraErrorType), {
              dailyMessage: t(getDeviceInUseErrorName(isCameraErrorType)),
            })}
          </Typography>
          <br />
          <Typography variant="body1" style={{ whiteSpace: "pre-line" }}>
            {t(getStepOneOfDeviceError(isCameraErrorType))}
          </Typography>
          <Typography variant="body1" style={{ whiteSpace: "pre-line" }}>
            {t("micCamCheck:step.two.reload.the.page")}
          </Typography>
          <br />
          <Typography variant="body1" style={{ whiteSpace: "pre-line" }}>
            {t("micCamCheck:step.three.please.restart.the.device")}
          </Typography>
        </span>
      }
      troubleShootLink={t(getMicCamTroubleshootLink(osName))}
      showTroubleshootLink
      hasDivider
    />
  );
};
